module.exports = __webpack_public_path__ + "img/code.bd57e1b9.svg";